<template>
  <button @click="$emit('click')" :disabled="disabled">
    <svg
      v-if="direction === 'left'"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ArrowButton',
  props: {
    direction: {
      type: String,
      required: true,
      validator: str => ['left', 'right'].includes(str),
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  background: none;
  border: 1px solid $color-grayscale-700;
  outline: none;
  box-sizing: border-box;
  line-height: 0;
  cursor: pointer;

  &:active {
    background: $color-primary-2;
  }

  &:disabled {
    visibility: hidden;
  }
}
</style>
